// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ixAAfICcj3D2Pyq8mYa8 {
  position: relative;
  overflow: hidden;
  padding: 1.5rem 0;
  background-color: var(--store-switcher-block-bg);
  transition: max-height 0.2s linear
}

.ixAAfICcj3D2Pyq8mYa8.u9Ib5TBdF6y32_eBDrfg {
    visibility: hidden;
    opacity: 0;
    max-height: 0;
    padding: 0;
  }

.vBVjsBCb5KsJWUV7c3iQ,
.pgk6fvwokEUhYymV43Uo {
  width: 100%;
  display: flex;
}

.vBVjsBCb5KsJWUV7c3iQ {
  justify-content: space-between;
}

.pgk6fvwokEUhYymV43Uo {
  margin-top: 1rem;
  align-items: center;
}

.tElyBlTV1nIJgq7WBO_K {
  padding: 0.8125rem 1rem;
  margin-left: 1rem;
}

.szgc4cdDlr71doyv1OPa {
  color: var(--store-switcher-block-text);
}

.JAFKxsWmlSRlpZQrXATh {
  cursor: pointer;
}

@media only screen and
  (min-width: 640px) and
  (max-width: 1023px) {
  .szgc4cdDlr71doyv1OPa {
    width: 100%;
    max-width: 80%;
  }
}

@media only screen and
  (max-width: 639px) {
  .ixAAfICcj3D2Pyq8mYa8 {
    position: relative;
    overflow: hidden;
  }

  .szgc4cdDlr71doyv1OPa {
    width: 100%;
    max-width: 95%;
  }

  .pgk6fvwokEUhYymV43Uo {
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }

  .tElyBlTV1nIJgq7WBO_K {
    margin-top: 1rem;
    margin-left: 0;
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/StoreSwitcherBlock/StoreSwitcherBlock.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAe;EACf,gDAAgD;EAChD;AAQF;;AANE;IACE,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,UAAU;EACZ;;AAGF;;EAEE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,uBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,eAAe;AACjB;;AAEA;;;EACE;IACE,WAAW;IACX,cAAc;EAChB;AACF;;AAEA;;EACE;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,WAAW;EACb;AACF","sourcesContent":[".storeSwitcherBlock {\n  position: relative;\n  overflow: hidden;\n  padding: 24px 0;\n  background-color: var(--store-switcher-block-bg);\n  transition: max-height 0.2s linear;\n\n  &.hidden {\n    visibility: hidden;\n    opacity: 0;\n    max-height: 0;\n    padding: 0;\n  }\n}\n\n.topBlock,\n.bottomBlock {\n  width: 100%;\n  display: flex;\n}\n\n.topBlock {\n  justify-content: space-between;\n}\n\n.bottomBlock {\n  margin-top: 16px;\n  align-items: center;\n}\n\n.continueBtn {\n  padding: 13px 16px;\n  margin-left: 16px;\n}\n\n.text {\n  color: var(--store-switcher-block-text);\n}\n\n.icon {\n  cursor: pointer;\n}\n\n@media (--tablet) {\n  .text {\n    width: 100%;\n    max-width: 80%;\n  }\n}\n\n@media (--mobile) {\n  .storeSwitcherBlock {\n    position: relative;\n    overflow: hidden;\n  }\n\n  .text {\n    width: 100%;\n    max-width: 95%;\n  }\n\n  .bottomBlock {\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n  }\n\n  .continueBtn {\n    margin-top: 16px;\n    margin-left: 0;\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"storeSwitcherBlock": `ixAAfICcj3D2Pyq8mYa8`,
	"hidden": `u9Ib5TBdF6y32_eBDrfg`,
	"topBlock": `vBVjsBCb5KsJWUV7c3iQ`,
	"bottomBlock": `pgk6fvwokEUhYymV43Uo`,
	"continueBtn": `tElyBlTV1nIJgq7WBO_K`,
	"text": `szgc4cdDlr71doyv1OPa`,
	"icon": `JAFKxsWmlSRlpZQrXATh`
};
export default ___CSS_LOADER_EXPORT___;
